import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';

export const StyledSvg = styled.svg`
  height: ${(props) => props.theme.font.size.sm};
  width: ${(props) => props.theme.font.size.sm};
  border-radius: ${(props) => props.theme.radius.md};
  vertical-align: center;
`;
